'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setWixStyles;

var _CssStyles = require('./CssStyles');

var _CssStyles2 = _interopRequireDefault(_CssStyles);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLE_ID = 'wix-react-dropdown-styles-' + Math.ceil(Math.random() * 1000);
var WixStyles = null;

function getStyles(wixStyleId) {
    if (WixStyles) {
        return new Promise(function (resolve) {
            resolve(WixStyles);
        });
    } else {
        var p1 = new Promise(function (resolve) {
            Wix.Styles.getStyleParams(function (styles) {
                return resolve(styles);
            });
        });
        var p2 = new Promise(function (resolve) {
            Wix.Styles.getSiteColors(function (colors) {
                return resolve(colors);
            });
        });
        var p3 = new Promise(function (resolve) {
            Wix.Styles.getSiteTextPresets(function (txts) {
                return resolve(txts);
            });
        });

        return new Promise(function (resolve) {
            Promise.all([p1, p2, p3]).then(function (styles) {
                var WixStyles = {
                    params: styles[0],
                    colors: styles[1],
                    fonts: styles[2]
                };
                resolve(WixStyles);
            });
        });
    }
}

var timeoutId = null;
var listenerId = null;
var firstTimeStyles = {};
var globalWixParams = null;
function setWixStyles(frame, type, wixParams, isHebrew, wixStyleId) {
    globalWixParams = { wixParams: wixParams };

    timeoutId && clearTimeout(timeoutId);
    listenerId && Wix.removeEventListener(Wix.Events.STYLE_PARAMS_CHANGE, listenerId);

    var styleElem = (0, _jquery2.default)('style#' + STYLE_ID + '[data-frame=' + frame + ']');
    var stylePromise = null;

    if (!(styleElem && styleElem.length)) {
        styleElem = (0, _jquery2.default)('<style id="' + STYLE_ID + '" data-frame="' + frame + '"></style>');
        (0, _jquery2.default)('head').append(styleElem);
    }

    if (_lodash2.default.isEmpty(firstTimeStyles)) {
        stylePromise = new Promise(function (resolve) {
            getStyles(wixStyleId).then(function (styles) {
                firstTimeStyles = styles;
                resolve();
            });
        });
    } else {
        stylePromise = Promise.resolve({});
    }

    stylePromise.then(function () {
        var css = (0, _CssStyles2.default)(frame, type, firstTimeStyles, globalWixParams.wixParams, isHebrew).toString();
        styleElem.text(css);

        listenerId = Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, function (params) {
            timeoutId = setTimeout(function () {
                var newStyles = Object.assign({}, firstTimeStyles);
                newStyles.params = params;
                var css = (0, _CssStyles2.default)(frame, type, newStyles, globalWixParams.wixParams, isHebrew).toString();
                styleElem.text(css);
            }, 500);
        });
    });
}